import { useEffect, useState } from 'react'

export function useCameras() {
  const [devices, setDevices] = useState([])

  useEffect(() => {
    async function fetchDevices() {
      const allDevices = await navigator.mediaDevices.enumerateDevices()
      const videoDevices = allDevices.filter((d) => d.kind === 'videoinput')
      setDevices(videoDevices)
    }
    fetchDevices()
  }, [])

  return devices
}
